import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { DriverService } from './driver.service';
import { DriverController } from './driver.controller';
import { DriverEntity } from './driver-entity';


@Module({
  imports: [TypeOrmModule.forFeature([DriverEntity])],
  controllers: [DriverController],
  providers: [DriverService,ApplicationExceptionHandler],
})
export class DriverModule {}